var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.5 15C17.5376 15 20 12.5376 20 9.5C20 6.46243 17.5376 4 14.5 4C11.4625 4 9.00002 6.46243 9.00002 9.5C9.00002 12.5376 11.4625 15 14.5 15ZM14.5 17C18.6422 17 22 13.6421 22 9.5C22 5.35786 18.6422 2 14.5 2C10.3579 2 7.00002 5.35786 7.00002 9.5C7.00002 13.6421 10.3579 17 14.5 17Z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.2071 13.7929C10.5976 14.1834 10.5976 14.8166 10.2071 15.2071L4.20711 21.2071C3.81658 21.5976 3.18342 21.5976 2.79289 21.2071C2.40237 20.8166 2.40237 20.1834 2.79289 19.7929L8.79289 13.7929C9.18342 13.4023 9.81658 13.4023 10.2071 13.7929Z","key":1})]);
}

Search.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"currentColor"};

module.exports = Search;

Search.default = Search;
